class DiscountApplication {
  constructor(
    type,
    title,
    value,
    value_type,
    allocation_method,
    target_selection,
    target_type,
    total_allocated_amount,
  ) {
    this.type = type;
    this.title = title;
    this.value = value;
    this.value_type = value_type;
    this.allocation_method = allocation_method;
    this.target_selection = target_selection;
    this.target_type = target_type;
    this.total_allocated_amount = total_allocated_amount;
  }
}

class ShowAutoDiscount {
  constructor(variantid) {
    this.variantid = variantid;
    this.productDescriptionContainer = document.querySelector(
      ".product-description-container",
    );
    this.atcBtn = document.querySelector("button.product-form__add-button");
    console.log("ShowAutoDiscount has been initiated!");
    this.checkCart();
  }

  // check Cart object
  checkCart = async () => {
    try {
      const response = await fetch("/cart.js");
      const data = await response.json();
      if (data) {
        if (data.items.every((item) => item.id !== this.variantid)) {
          await this.addProduct(this.variantid);
          return;
        } else {
          await this.getCart();
          return;
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // get Cart object
  getCartandRemove = async () => {
    try {
      const response = await fetch("/cart.js");
      const data = await response.json();
      console.log("Data", data.items);
      // check for discount
      if (data) {
        for (let i = 0; i < data.items.length; i++) {
          if (data.items[i].id === this.variantid) {
            if (data.items[i].line_level_discount_allocations.length > 0) {
              let iter = data.items[i].line_level_discount_allocations[0];
              const discount = new DiscountApplication(
                iter.discount_application.type,
                iter.discount_application.title,
                iter.discount_application.value,
                iter.discount_application.value_type,
                iter.discount_application.allocation_method,
                iter.discount_application.target_selection,
                iter.discount_application.target_type,
                iter.discount_application.total_allocated_amount,
              );
              console.log("discount", discount);
              if (discount) {
                await this.removeProduct(this.variantid, 0);
                this.addCoupon(discount);
              }
            } else {
              await this.removeProduct(data.items[i].id,0);
            }
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // get Cart object
  getCart = async () => {
    try {
      const response = await fetch("/cart.js");
      const data = await response.json();
      console.log("Data", data.items);
      // check for discount
      let isBundleInCart = data.items.some(item => 
        item.discounts && item.discounts.some(discount => discount.title === "BUNDLE")
      );
      if (data) {
        for (let i = 0; i < data.items.length; i++) {
          if (data.items[i].id === this.variantid) {
            if (data.items[i].line_level_discount_allocations.length > 0) {
              let iter = data.items[i].line_level_discount_allocations[0];
              const discountValue = isBundleInCart ? iter.amount / 100 : iter.discount_application.value;
              const discount = new DiscountApplication(
                iter.discount_application.type,
                iter.discount_application.title,
                discountValue,
                iter.discount_application.value_type,
                iter.discount_application.allocation_method,
                iter.discount_application.target_selection,
                iter.discount_application.target_type,
                iter.discount_application.total_allocated_amount,
              );
              console.log("discount", discount);
              if (discount) {
                await this.removeProduct(
                  this.variantid,
                  data.items[i].quantity,
                );
                this.addCoupon(discount);
              }
            }
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // clear coupon elements
  clearCoupon = () => {
    const oldCoupons = document.querySelectorAll(".createdCoupon");
    oldCoupons.forEach((oldCoupon) => {
      oldCoupon.remove();
    });
  };

  // add coupon element
  addCoupon = (discount) => {
    this.clearCoupon();
    let div = document.createElement("div");
    div.setAttribute("class", "createdCoupon");
      let span = document.createElement("p");
    span.style.cssText =
      "margin: 0; text-align: left; padding-left: 0.75rem; line-height: 1rem;";
    let imgDiv = document.createElement("div");
    imgDiv.classList.add("imgContainerCoupon");
    imgDiv.innerHTML = `<img class="imgCoupon" src="https://cdn.shopifycdn.net/s/files/1/0736/3864/1973/files/byteex_white4x_coupon.png?v=1717134117" alt="coupon_icon" draggable="false" />`;
    let contentDiv = document.createElement("div");
    contentDiv.classList.add("contentCoupon");
    switch (discount.value_type) {
      case "fixed_amount":
        span.innerHTML = `<p style="font-family: 'Archivo Black', sans-serif; font-size: 1.1rem; margin: 0; font-weight: 800; color: #273A3D;">$${parseInt(discount.value)}</p><p style="font-family: 'Archivo Black', sans-serif; font-size: 0.8rem; margin: 0; font-weight: 800; color: #273A3D">VOUCHER</p><p style="font-family: Archivo, sans-serif; font-size: 0.5rem; margin: 0; font-weight: 700; color: #273A3D;">MIN. $100 SPENT</p>`;
        break;
      case "percentage":
        span.innerHTML = `<p style="font-family: 'Archivo Black', sans-serif; font-size: 1.1rem; margin: 0; font-weight: 800; color: #273A3D;">$${parseInt(discount.value)}% off</p><p style="font-family: 'Archivo Black', sans-serif; font-size: 0.8rem; margin: 0; font-weight: 800; color: #273A3D">VOUCHER</p><p style="font-family: Archivo, sans-serif; font-size: 0.5rem; margin: 0; font-weight: 700; color: #273A3D;">MIN. $100 SPENT</p>`;
        break;
      default:
        break;
    }
    let btn = document.createElement("button");
    btn.textContent = "CLAIM NOW";
    btn.style.cssText =
      "font-family: Archivo, sans-serif; background-color: #273a3d; color: #fff; border-radius: 2px; border: 1px solid #44979F; width: 75px; padding: 0.25rem 0.5rem; font-size: 0.5rem; font-weight: 800; margin: 0 auto; cursor: pointer;";
    btn.setAttribute("data-action", "add-to-cart");
    btn.addEventListener("click", (e) => {
      e.target.textContent = "CLAIMED";
      e.target.disabled = "true";
      e.target.style.cssText =
        "font-family: Archivo, sans-serif; background-color: transparent; color: #fff; border-radius: 2px; border: 0px solid #44979F; width: 75px; padding: 0.25rem 0.5rem; font-size: 0.5rem; font-weight: 800; margin: 0 auto;";
      const coupon = document.querySelector(".createdCoupon");
      coupon.querySelector("div:nth-of-type(1)").style.background = "#fff";
      let pElements = coupon.querySelectorAll("div:nth-of-type(2) > p > * ")
      pElements.forEach(p => {
        p.style.color = "#fff";
      });
      coupon.querySelector("div:nth-of-type(1) > img").setAttribute("src", "https://cdn.shopifycdn.net/s/files/1/0736/3864/1973/files/byteex_dark4x_coupon.png?v=1717134117");
      coupon.querySelector("div:nth-of-type(2)").style.background = "linear-gradient(180deg, #44979F 0%, #183639 100%)";
      coupon.querySelector("div:nth-of-type(2)").style.color = "#fff";
      this.atcBtn.click();
    });
    contentDiv.append(span, btn);
    div.append(imgDiv, contentDiv);
    this.productDescriptionContainer.prepend(div);
  };

  // add product to Cart
  addProduct = async (variant_id) => {
    try {
      let formData = { items: [{ id: variant_id, quantity: 1 }] };
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      if (data) {
        console.log("ADD", data.items);
        await this.getCartandRemove();
      }
    } catch (error) {
      console.log(error);
    }
  };

  // remove product to Cart
  removeProduct = async (variant_id, prevQty = 0) => {
    try {
      let updates = { [variant_id]: prevQty };
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      });
      const data = await response.json();
      if (data) {
        console.log("REMOVE", data.items);
      }
    } catch (error) {
      console.log(error);
    }
  };
}